import React, { useEffect, useState } from 'react';
import MetricsTable from '@/pages/intelligence/pages/TopCharts/PCGames/MetricsTable';
import {
  buriedPointPage,
  typeIdObj,
  pointInter,
} from '@/pages/home/utils/buriedPoint';
import {
  dbiPageLogMes,
  dbiBtnLogMes,
} from '@/pages/intelligence/utils/buriedPointCfg';
// import { pcMetricTableCloums } from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import { pcMetricTableCloums } from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import { useIntl, history } from 'umi';
import { TopchartPageId } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import moment from 'moment';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';
import {
  commonPCConsoleDefaultFilterValue,
  handleMetricTableFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import useEarliesTimeHasData from '@/pages/intelligence/hooks/useEarliesTimeHasData';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
import { DATASOURCE_METRICS_BACKEND_PC } from '@intelligence/pages/TopCharts/PCGames/_config/constant';
import { fetchGuideStatus } from '@/pages/intelligence/services/topcharts';
import { defaultMetrictableApiParams } from '@intelligence/pages/TopCharts/PCGames/MetricsTable/utils/constant';
import {
  dbiTopChartsBtnLogMes,
  btnPointInter,
} from '@/pages/intelligence/utils/topChartsBuriedPointCfg';
import {
  getTopPCMetricTableCustomValidUrlParams,
  topchartPCMetrictableValidCfg,
  hasShortLinkRatio,
} from '@intelligence/_config/urlPageValidCfg';
import {
  getOriginalShortLinkFilter,
  URL_FILTER_KEY,
  ShortLinkQueryType,
  URL_CHART_METRIC,
  URL_TABLE_SCROLL_SEG,
  URL_CHART_TYPE,
} from '@intelligence/utils/urlPathCfg';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

export default function PCMetricsTable() {
  const entityType = 'pc';
  const filterKeyList = [
    filterKeyMap.MY_FILTER,
    filterKeyMap.RANGE_TIME,
    filterKeyMap.REGION,
    filterKeyMap.GENRETOR,
    filterKeyMap.ALL_Games,
    filterKeyMap.PUBLISHER,
    filterKeyMap.PCU_RANGE,
    filterKeyMap.PHYSICAL_RANGE,
    filterKeyMap.DIGITAL_RANGE,
    filterKeyMap.PRICE_RANGE,
    filterKeyMap.PREMIUM_RANGE,
    filterKeyMap.ALL_COMPANYS,
    filterKeyMap.RELEASE_TIME,
  ];
  const companyFilterParams = {
    entity_type: entityType,
    source: 'gamalytic',
    data_sources: ['newzoo', 'mscience', 'gamalytic', 'npd'],
    metric: 'gamalytic__pcu',
    region_type: 'region',
    regions: ['global'],
    granularity: 'monthly',
    start_date: '',
    end_date: '',
    page_size: 500,
    search_name: '',
    page: 1,
    source_metric: {
      gamalytic: ['gamalytic__pcu'],
    },
  };

  const defaultParams = {
    ...defaultMetrictableApiParams,
    entity_type: entityType,
    order_metric: 'source_steam__pcu',
    order_source: 'source_steam',
    source_metrics: DATASOURCE_METRICS_BACKEND_PC,
    topchart_name: 'Metrics Table',
    region_type: 'market',
    regions: ['global'],
    date_type: 'monthly',
    gsd_types: ['NETWORK'],
  };

  const hasUrlShortLink = hasShortLinkRatio.topPCMetrictable;
  const [shortLinkLoading, setShortLinkLoading] = useState(hasUrlShortLink);
  const [urlCustomParams, setUrlCustomParams] = useState({});
  const [shortLinkValidQuery, setShortLinkValidQuery] = useState({
    [URL_CHART_TYPE]: topchartPCMetrictableValidCfg?.[URL_CHART_TYPE]?.[0],
    [URL_CHART_METRIC]: topchartPCMetrictableValidCfg?.[URL_CHART_METRIC]?.[0],
    [URL_TABLE_SCROLL_SEG]:
      topchartPCMetrictableValidCfg?.[URL_TABLE_SCROLL_SEG]?.[0],
  });
  const [shortLinkFilterValue, setShortLinkFilterValue] = useState(null);

  const initPage = async () => {
    setShortLinkLoading(true);
    // 在url上取token，有则请求接口， 判断异常，返回函数值和url上的其他配置参数
    const { [URL_FILTER_KEY]: urlFilter } = await getOriginalShortLinkFilter();
    if (urlFilter) {
      // 有的筛选器的token时才用后面的参数，没有则不用
      const { params, validQuery } = getTopPCMetricTableCustomValidUrlParams(
        history,
        topchartPCMetrictableValidCfg,
        // pcMetricTableCloums,
        pcMetricTableCloums,
      );
      setUrlCustomParams({ ...params });
      setShortLinkValidQuery({ ...shortLinkValidQuery, ...validQuery });
      setShortLinkFilterValue(urlFilter);
    }
    setShortLinkLoading(false);
  };

  useEffect(() => {
    // 进入页面时判断是否有tokenQuery等，有则进入
    initPage();
  }, []);

  return (
    <>
      <MarqueeBanner />
      <MetricsTableComp
      entityType={entityType}
      pageLogInfoMes={dbiPageLogMes.topChartsPCGamesMetricsTable}
      filterKeyList={filterKeyList}
      companyFilterParams={companyFilterParams}
      defaultParams={defaultParams}
      // tableCloumsList={pcMetricTableCloums}
      tableCloumsList={pcMetricTableCloums}
      downloadLogConfig={
        dbiTopChartsBtnLogMes?.[
          `${entityType}_${TopchartPageId?.MetricsTable}_TopChartsMetricsTableDownload`
        ]
      }
      downloadBtnLogConfig={
        dbiTopChartsBtnLogMes?.[
          `${entityType}_${TopchartPageId?.MetricsTable}_TopChartsMetricsTableDownloadBtn`
        ]
      }
      hasUrlShortLink={hasUrlShortLink}
      urlCustomParams={urlCustomParams}
      shortLinkValidQuery={shortLinkValidQuery}
      shortLinkFilterValue={shortLinkFilterValue}
      shortLinkLoading={shortLinkLoading}
        hasScrollTableSegment={true}
      />
    </>
  );
}

interface IMetricsTableProps {
  entityType: string;
  pageLogInfoMes: pointInter;
  filterKeyList: string[];
  companyFilterParams: object;
  defaultParams: object;
  tableCloumsList: any[];
  downloadLogConfig?: btnPointInter;
  downloadBtnLogConfig?: btnPointInter;
  hasUrlShortLink: boolean;
  // 页面操作的有效配置
  shortLinkValidQuery: ShortLinkQueryType;
  // 从短链接通过接口获取的url筛选器
  shortLinkFilterValue: any;
  // url链接的其他参数组装成的参数
  urlCustomParams: object;
  shortLinkLoading: boolean;
  hasScrollTableSegment?: boolean;
}
export function MetricsTableComp(props: IMetricsTableProps) {
  const {
    entityType,
    pageLogInfoMes,
    filterKeyList,
    companyFilterParams,
    defaultParams,
    tableCloumsList,
    downloadLogConfig,
    downloadBtnLogConfig,
    hasUrlShortLink,
    urlCustomParams,
    shortLinkValidQuery,
    shortLinkFilterValue,
    shortLinkLoading,
    hasScrollTableSegment,
  } = props;
  const { formatMessage } = useIntl(); // 中英切换方法

  const { filterLoading, regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.metricTable,
  });

  const { latestTimeTypeHasData } = useEarliesTimeHasData({
    filterType: hasDataTimerParams?.pcMetricTable?.type,
  });

  /** 首次展示下载弹窗提示 */
  const [firstDownLoadBubleShow, setFirstDownLoadBubleShow] = useState(false);

  const getFetchGuideStatus = async (params: any) => {
    try {
      const res = await fetchGuideStatus(params);
      if (res?.code === 0) {
        setFirstDownLoadBubleShow(res?.data);
      }
    } catch (e) {
    } finally {
    }
  };

  useEffect(() => {
    buriedPointPage(pageLogInfoMes);

    getFetchGuideStatus({
      // Topchart榜单第一个落地页下载按钮提示， 点与Activeuser共用一个,因为只需要点一次就全局关掉
      button_id: dbiBtnLogMes.topchartMobileGameActiveUserDownLoadTip.buttonId,
      type_id: typeIdObj.intelligence,
    });
  }, []);

  const defaultFilterValue = {
    ...commonPCConsoleDefaultFilterValue,
  };
  const filterCfg: TopchartFilterCfgType = {
    filterKeyList,
    companyFilterParams,
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
      [filterKeyMap.RANGE_TIME]: {
        type: 'month',
        value: [moment().subtract(6, 'months'), moment().subtract(1, 'months')],
      },
    },
    specialParams: {
      regionOptions, // 国家筛选器options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: true,
      rangeTimeType: FilterTimeType.commonRange,
      disableIegg: false,
      disableAnnie: true,
      [filterKeyMap.ALL_Games]: {
        params: { entity_type: entityType, game_type: 'current_game' },
      },
      entityType,
    },
    showConfirmButton: true,
    haveFilterSaveBtn: true,
    handleFilterToApiParams: (params: any) =>
      handleMetricTableFilterParamsToApi(params, entityType),
    hasUrlShortLink,
  };

  return (
    <MetricsTable
      entityType={entityType}
      pageId={TopchartPageId.MetricsTable}
      pageLogInfo={pageLogInfoMes}
      tableCloumsList={tableCloumsList}
      hasRegionFilter={true}
      cardMetricName={formatMessage({ id: 'dbi_label_metrics' })}
      filterCfg={filterCfg}
      filterLoading={filterLoading || shortLinkLoading}
      rangeTimeComponentDefault={latestTimeTypeHasData}
      defaultParams={defaultParams}
      /** 首次展示下载弹窗提示 */
      firstDownLoadBubleShow={firstDownLoadBubleShow}
      setFirstDownLoadBubleShow={setFirstDownLoadBubleShow}
      downloadLogConfig={downloadLogConfig}
      downloadBtnLogConfig={downloadBtnLogConfig}
      urlCustomParams={urlCustomParams}
      shortLinkValidQuery={shortLinkValidQuery}
      shortLinkFilterValue={shortLinkFilterValue}
      hasScrollTableSegment={hasScrollTableSegment}
    />
  );
}
